import React from "react";

const TooltipIcon = () => (
  <img src="/assets/images/tooltip-icon.svg" alt="tooltip" />
);

export default TooltipIcon;
